import {
  http,
  Header,
  ContentType,
  qs,
  GetFormData,
  StatusCode,
  Global,
  Method
} from './api-util';

export const uploadImg = async ({ file }) => {
  const formData = GetFormData({ file });
  const { data } = await http({
    method: Method.POST,
    url: Global.BASE_URL + '/upload/img',
    headers: {
      [Header.ContentType]: ContentType.FormData
    },
    data: formData
  });

  const filePath = data.msg;

  return {
    filePath
  };
};
